<template>
  <div>
    <van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" is-link readonly
      @focus="onFocus" :required="required" :rules="[{ required: required, message: label+'不能为空'}]" />
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" name="abc" :title="title">
      <van-search v-model="search" placeholder="请输入" @input="OnInput"></van-search>
      <van-cell v-for="(item,index) in filterList" :key="index" :title="item[labelProp]" @click="onSelect(item)"
        is-link />
    </van-action-sheet>
  </div>
</template>

<script>
  export default {
    name: "StaticSingleSelect",
    data() {
      return {
        selectValue: this.value,
        show: false,
        options: [],
        search: "",
      };
    },
    props: {
      label: {
        type: String,
        default: "",
      },
      placeholder: {
        type: String,
        default: "请选择",
      },
      title: {
        type: String,
        default: "请选择",
      },
      // 是否必填
      required: {
        type: Boolean,
        default: false
      },
      value: {
        default: "",
      },
      selectkey: {},
      // 选项默认label属性
      labelProp: {
        type: String,
        default: "name"
      },
      // 选项默认value属性
      valueProp: {
        type: String,
        default: "id"
      },
      //传递进来的默认数组,
      //默认数据格式为{id:1,name:"111"}
      list: {
        type: Array,
        default: function() {
          return []
        }
      },
    },
    computed: {
      filterList() {
        let that = this
        // let filterList = []
        // that.options.forEach(function(item){
        //   if(typeof(item[that.labelProp]) == "number"){
        //     console.log(item[that.labelProp]);
        //   }
        // })
        return that.options.filter(m => m[that.labelProp] && m[that.labelProp].toString().indexOf(that.search) != -1)
      }
    },

    watch: {
      value(newVal) {
        this.selectValue = newVal;
      },
      selectkey(newVal) {
        let that = this
        let filterList = that.options.filter(m => m[that.valueProp] == newVal)
        if (filterList.length > 0) {
          that.selectValue = filterList[0][that.labelProp]
        }
      },
      list(newVal) {
        let that = this
        this.options = this.$utils.clone(newVal)
        let filterList = that.options.filter(m => m[that.valueProp] == that.selectkey)
        if (filterList.length > 0) {
          that.selectValue = filterList[0][that.labelProp]
        }
      }
    },
    methods: {
      // 展示选项
      onFocus: function() {
        this.show = true;
      },
      //搜索框变化事件
      OnInput: function() {
        //this.LoadItem()
      },
      onSelect: function(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        let that = this
        this.show = false;
        this.selectValue = item[that.labelProp];
        this.$emit("input", this.selectValue);
        this.$emit("update:selectkey", item[that.valueProp]);
        this.$emit('changeSelect', item)
      },
      LoadData: function() {
        let that = this
        this.options = this.$utils.clone(this.list)
        if (that.selectkey) {
          let filterList = that.options.filter(m => m[that.valueProp] == that.selectkey)
          if (filterList.length > 0) {
            that.selectValue = filterList[0][that.labelProp]
          }
        }
      },
    },
    mounted: function() {

      this.LoadData();
    },
  };
</script>

<style>
</style>
